import * as PIXI from "pixi.js";

class WebGLConfetti {
  constructor(app) {
    this.app = app;
    this.container = new PIXI.Container();
    this.confetti = [];
    this.time = 0;
    this.init();
  }

  init() {
    const confettiCount = 50;
    const colors = [
      0xff6b6b, 0x4ecdc4, 0x45b7d1, 0x96ceb4, 0xfeca57, 0xff9ff3, 0x54a0ff,
    ];
    const shapes = ["rectangle", "square", "circle"];

    for (let i = 0; i < confettiCount; i++) {
      const piece = new PIXI.Graphics();
      const shape = shapes[Math.floor(Math.random() * shapes.length)];
      const color = colors[Math.floor(Math.random() * colors.length)];

      // Create different shapes
      if (shape === "rectangle") {
        piece.rect(-6, -3, 12, 6);
      } else if (shape === "square") {
        piece.rect(-4, -4, 8, 8);
      } else {
        // circle
        piece.circle(0, 0, 4);
      }

      piece.fill(color);

      // Starting position - burst from center-top area
      piece.x = this.app.screen.width * 0.5 + (Math.random() - 0.5) * 200;
      piece.y = this.app.screen.height * 0.3 + (Math.random() - 0.5) * 100;

      // Physics properties
      piece.vx = (Math.random() - 0.5) * 15;
      piece.vy = Math.random() * -8 - 5; // Initial upward velocity
      piece.gravity = 0.3;
      piece.rotationSpeed = (Math.random() - 0.5) * 0.2;
      piece.life = 1.0;
      piece.decay = Math.random() * 0.003 + 0.001;
      piece.baseScale = Math.random() * 0.8 + 0.6;

      // Air resistance coefficients
      piece.airResistanceX = 0.995;
      piece.airResistanceY = 0.997;

      this.confetti.push(piece);
      this.container.addChild(piece);
    }

    this.updateBound = () => this.update();
    this.app.ticker.add(this.updateBound);
  }

  update() {
    this.time += 0.016;

    this.confetti.forEach((piece, index) => {
      // Apply physics
      piece.vy += piece.gravity;
      piece.x += piece.vx;
      piece.y += piece.vy;

      // Air resistance
      piece.vx *= piece.airResistanceX;
      piece.vy *= piece.airResistanceY;

      // Rotation
      piece.rotation += piece.rotationSpeed;

      // Life decay
      piece.life -= piece.decay;

      // Respawn when life runs out or falls off screen
      if (piece.life <= 0 || piece.y > this.app.screen.height + 50) {
        // Reset to burst position
        piece.x = this.app.screen.width * 0.5 + (Math.random() - 0.5) * 200;
        piece.y = this.app.screen.height * 0.3 + (Math.random() - 0.5) * 100;
        piece.vx = (Math.random() - 0.5) * 15;
        piece.vy = Math.random() * -8 - 5;
        piece.life = 1.0;
        piece.rotation = 0;
      }

      // Bounce off sides
      if (piece.x < -20) {
        piece.x = -20;
        piece.vx *= -0.6;
      }
      if (piece.x > this.app.screen.width + 20) {
        piece.x = this.app.screen.width + 20;
        piece.vx *= -0.6;
      }

      // Update visual properties
      piece.alpha = piece.life * 0.9;
      piece.scale.set(piece.baseScale * piece.life);
    });
  }

  destroy() {
    try {
      if (this.updateBound && this.app && this.app.ticker) {
        this.app.ticker.remove(this.updateBound);
        this.updateBound = null;
      }

      this.confetti = [];

      if (this.container) {
        this.container.destroy({ children: true, texture: true });
        this.container = null;
      }
    } catch (e) {
      console.warn("Error destroying WebGLConfetti:", e);
    }
  }
}

export default WebGLConfetti;
